import { render, staticRenderFns } from "./DataLabelGroup.vue?vue&type=template&id=334957ec&"
import script from "./DataLabelGroup.vue?vue&type=script&lang=js&"
export * from "./DataLabelGroup.vue?vue&type=script&lang=js&"
import style0 from "./DataLabelGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports